import { render, staticRenderFns } from "./Anamnes.vue?vue&type=template&id=450993d7&"
import script from "./Anamnes.vue?vue&type=script&lang=js&"
export * from "./Anamnes.vue?vue&type=script&lang=js&"
import style0 from "./Anamnes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports